import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/AboutPage.head';
import { AboutPage } from '@pages/AboutPage';

export const Route = createFileRoute('/about')({
  component: AboutPage,
  head: () => head,
});
